/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const SurnamePage = lazy(() => import('./pages/SurnamePage'))
const JapanNLIHP = lazy(() => import('./pages/JapanNLIHP'))
const KosekiPage = lazy(() => import('./pages/KosekiPage'))

export default [
  <SiteRoute key="nlihp" exact path="/" component={JapanNLIHP} />,
  <SiteRoute key="surname" path="/surname/:surname" component={SurnamePage} />,
  <SiteRoute key="koseki" path="/koseki" component={KosekiPage} />,
]
